import type { ReactNode } from 'react';

export const symbol_full_coverage: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-120q-24 0-42-18t-18-42v-459q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v459h584q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140Zm169-171q-24 0-42-18t-18-42v-459q0-12.75 8.63-21.38Q266.25-840 279-840h611q12.75 0 21.38 8.62Q920-822.75 920-810v459q0 24-18 42t-42 18H309Zm0-60h551v-429H309v429Zm116-131h108q12.75 0 21.38-8.63Q563-499.25 563-512v-155q0-12.75-8.62-21.38Q545.75-697 533-697H425q-12.75 0-21.37 8.62Q395-679.75 395-667v155q0 12.75 8.63 21.37Q412.25-482 425-482Zm225 0h80q18 0 31-13t13-31q0-18-13-31t-31-13h-80q-18 0-31 13t-13 31q0 18 13 31t31 13Zm0-127h80q18 0 31-13t13-31q0-18-13-31t-31-13h-80q-18 0-31 13t-13 31q0 18 13 31t31 13ZM309-351v-429 429Z"
		/>
	</svg>
);
